<section
  class="verify-empcode-section container-fluid sts-section sts-form">


  <app-sts-section-header key="sts-verify-empcode-header" [errors]="errors">Employer Code
  </app-sts-section-header>

  <app-sts-section-body key="sts-verify-empcode-body">
    <div class="col-24 verify-instruction-top">
      Please Verify Your Employer Code
    </div>
  </app-sts-section-body>

  <form (ngSubmit)="captcha.submit()" autocomplete="off"
        #form="ngForm"
        [formGroup]="empForm"
        class="sts-form animate-all">

    <div class="row sts-form-row">
      <div class="col-24 verify-instruction-bottom"
           app-sts-cms-txt
           key="sts-enter-your-empcode-for-reset">
        Please enter your employer code
        and select <span class="bold">Next</span>.
      </div>
    </div>


    <div class="row ">
      <div class="col-6 label-node left-label ">
        <label for="sts_pick_code" app-sts-cms-txt key="sts-emp-code">Employer Code:</label>
      </div>
      <div class="col-9 above-captcha">
        <input type="text"
               name="sts_pick_code"
               id="sts_pick_code"
               formControlName="code"
               maxlength="100"
               [ngClass]="{'has-errors' : hasErrors}"
               class="sts-textbox" >
        <app-sts-show-error key="sts-field-error-empcode-required"
                            description="Employer Code is is not valid"
                            [show]="empForm.controls['code'].invalid && empForm.controls['code'].errors['pattern']"></app-sts-show-error>
      </div>
    </div>

    <div class="row ">
      <div class="col-md-9 col-md-offset-6">
        <div style="margin-bottom: 10px; padding-top: 10px;">
          <app-sts-captcha (onValidate)="onSubmit($event)"></app-sts-captcha>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-offset-6 col-md-14">
        <button app-sts-cms-txt key="sts-cancel-button"
                class="sts-btn other-sts-btn"
                (click)="gotoHome()">
          Cancel
        </button>
        <app-sts-button [submit]="submitter"
                key="sts-next-button">
          Next
        </app-sts-button>
      </div>
    </div>

  </form>



</section>
